import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';
import * as Auth from '../../auth/';
import { config } from '../../common/';
import { useRouter } from '../../common/RouterHooks';
import SurveyFollowupLayoutContainer, { SurveyFollowupLayoutContainerProps } from './containers/SurveyFollowupLayoutContainer';

export interface RouterSurveyFollowupLayout {
}

const SurveyFollowupLayout: React.FC<SurveyFollowupLayoutContainerProps> = (containerProps) => {
    const { t } = useTranslation();
    const routeProps = useRouter();
    return (
        <SurveyFollowupLayoutContainer {...containerProps} t={t} routeProps={routeProps} >
            {(props) => (
                <React.Fragment>
                    <Switch>
                        <Route path={[`${config.BaseURL}/surveyfollowup/confirm`, `${config.AlternativeBaseURL}/surveyfollowup/confirm`]} render={() => <Auth.SurveyFollowupConfirm name={props.name} email={props.email} />} />
                        <Route render={() => <Auth.SurveyFollowup setLayoutState={props.setLayoutState} />} />
                    </Switch>
                </React.Fragment>
            )}
        </SurveyFollowupLayoutContainer>
    );
};

export default SurveyFollowupLayout;
